<template>
  <v-container class="auth container--fluid" fill-height>
    <v-row justify="center">
      <v-col cols="4" class="auth__form-container">
        <a :href="linkHome">
          <logo class="auth__logo"></logo>
        </a>
        <component :is="currentComponent"></component>
      </v-col>
      <v-col cols="8" class="align-self-center justify-center auth__form-container--right centered">
        <registration-img></registration-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logo from '@/assets/logo.svg';
import RegistrationImg from '../components/RegistrationImg.vue';
import Login from '../components/forms/LoginForm.vue';
import SignUp from '../components/forms/SignUpForm.vue';
import ForgotPassword from '../components/forms/ForgotPasswordForm.vue';

export default {
  name: 'login',
  components: {
    RegistrationImg,
    logo,
    Login,
    SignUp,
    ForgotPassword,
  },
  data() {
    return {};
  },
  computed: {
    currentComponent() {
      return this.$route.name;
    },
    linkHome() {
      return 'https://www.ucime.se';
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
/* "scoped" attribute limit the CSS to this component only */
.container {
  padding: 0 !important;
  min-height: 100vh;
}
.v-application .align-self-center {
  padding-top: 15vh;
}

.auth {
  min-height: 100vh;

  &__form-container {
    padding: 8vh 6vw !important;
    &--right {
      background: #cce9ff;
      min-height: 100vh;
      padding: 0 70px !important;
    }
  }
  &__logo {
    width: 100px;
  }
}

input {
  margin: 10px 0;
  width: 100%;
  padding: 15px;
}

p {
  margin-top: 40px;
  font-size: 13px;
}

p a {
  text-decoration: underline;
  cursor: pointer;
}
@media only screen and (max-width: 968px) {
  .container .row {
    flex-direction: column !important;
  }
  .col-4,
  .col-8 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .v-application .align-self-center {
    padding-top: 6vh !important;
  }

  .auth {
    min-height: 20vh !important;
    display: flex;
    justify-content: center;

    &__form-container {
      padding: 8vh 6vw !important;
      &--right {
        background: #cce9ff;
        min-height: 20vh !important;
        padding: 0 30px !important;
      }
    }
    &__logo {
      width: 100px;
    }
  }
}
</style>
